import { getRONFElements } from "./cipAPI";

const ronfElementsCache = new Map();
const ronfElementsInFlight = new Map();

const normalizeWaterTypeKey = (waterType) =>
  String(waterType || "")
    .trim()
    .toLowerCase();

const formatRONFElements = (response) => {
  if (!response?.data || !Array.isArray(response.data)) {
    return [];
  }

  return response.data.map((element) => ({
    id: element.name,
    label: element.name,
    value: element.name,
    comment: element.comment,
    permissions: element.permissions,
  }));
};

export const clearRONFElementsCache = () => {
  ronfElementsCache.clear();
  ronfElementsInFlight.clear();
};

export const fetchRONFElementsWithCache = async (waterType) => {
  const cacheKey = normalizeWaterTypeKey(waterType);

  if (!cacheKey) {
    return [];
  }

  if (ronfElementsCache.has(cacheKey)) {
    return ronfElementsCache.get(cacheKey);
  }

  if (ronfElementsInFlight.has(cacheKey)) {
    return ronfElementsInFlight.get(cacheKey);
  }

  const requestPromise = (async () => {
    const response = await getRONFElements(waterType);
    const formattedElements = formatRONFElements(response);
    ronfElementsCache.set(cacheKey, formattedElements);
    return formattedElements;
  })().finally(() => {
    ronfElementsInFlight.delete(cacheKey);
  });

  ronfElementsInFlight.set(cacheKey, requestPromise);
  return requestPromise;
};
